// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ly3b","textarea":"styles_textarea__8aAQU"};